// import React, { useContext, useEffect, useState } from "react";
// import { DContext } from "../../../context/Datacontext";
// import { useNavigate } from "react-router-dom";
// import { RiCloseFill } from "react-icons/ri";
// import { IoAdd } from "react-icons/io5";
// const CreateCourseModal = ({ open, onClose, onCreated, departments = [],courses =[] }) => {
//   const { BeURL } = useContext(DContext);
//   const navigate = useNavigate()

//   const [selectedDept, setSelectedDept] = useState(null);
//   // const [lastCourse,setLastCourse]=useState(null)

//   const [form, setForm] = useState({
//     title: "",
//     shortDescription: "",
//     description: "",
//     level: "",
//     language: "",
//   });

//   // validation state
//   const [touched, setTouched] = useState({});
//   const [errors, setErrors] = useState({});
//   const labels = {
//     title: "Title",
//     shortDescription: "Short description",
//     description: "Description",
//     level: "Level",
//     language: "Language",
//   };

//   // skills
//   const [skills, setSkills] = useState([]);
//   const [skillInput, setSkillInput] = useState("");
//   const [skillError, setSkillError] = useState("");

//   // faq
//   const [faq, setFaq] = useState({ question: "", answer: "" });
//   const [faqList, setFaqList] = useState([]);
//   const [faqError, setFaqError] = useState("");

//   // thumbnail
//   const [thumbnailFile, setThumbnailFile] = useState(null);
//   const [thumbnailPreview, setThumbnailPreview] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [creating, setCreating] = useState(false);

//   // helper validators
//   const validateField = (name, value) => {
//     if (!labels[name]) return "";
//     if (!value || value.toString().trim() === "") {
//       return `${labels[name]} is required`;
//     }
//     return "";
//   };

//   const getInputClass = (name) => {
//     // returns tailwind border class depending on validation state
//     if (!touched[name]) return "border-gray-300 focus:outline-none focus:ring-1 focus:ring-primary-200";
//     if (errors[name]) return "border-red-500 focus:border-red-500 focus:ring-0";
//     return "border-green-500 focus:border-green-500 focus:ring-0";
//   };

//   const renderError = (name) => {
//     if (!touched[name] || !errors[name]) return null;
//     return <p className="text-xs text-red-500 mt-1">{errors[name]}</p>;
//   };



// // useEffect(() => {
// //   const fetchLastCourse = async () => {
// //     try {
// //       const res = await fetch(`${BeURL}/lastcourse`, {
// //         method: "GET",
// //         credentials: "include",
// //       });

// //       const data = await res.json();

// //       if (data.success) {
// //         setLastCourse(data._id)
// //       }

// //     } catch (err) {
// //       console.error("Error in Fetch last courses", err);
// //     }
// //   };

// //   fetchLastCourse();
// // }, [BeURL]);


//   // reset
//   const resetAll = () => {
//     setSelectedDept(null);
//     setForm({
//       title: "",
//       shortDescription: "",
//       description: "",
//       level: "",
//       language: "",
//     });
//     setSkills([]);
//     setSkillInput("");
//     setFaq({ question: "", answer: "" });
//     setFaqList([]);
//     setThumbnailFile(null);
//     setThumbnailPreview(null);
//     setUploading(false);
//     setCreating(false);
//     setTouched({});
//     setErrors({});
//     setSkillError("");
//     setFaqError("");
//   };

//   useEffect(() => {
//     if (!open) resetAll();
//   }, [open]);

//   if (!open) return null;

//   // handle form field changes
//   const handleFormChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));

//     // mark touched for this field
//     setTouched((prev) => ({ ...prev, [name]: true }));

//     // validate this field realtime and clear errors when valid
//     const err = validateField(name, value);
//     setErrors((prev) => ({ ...prev, [name]: err }));
//   };

//   // department selection (mark touched so error shows if none)
//   const handleSelectDept = (d) => {
//     const id = d.id || d._id || d.value;
//     const name = d.name || d.label || d;
//     setSelectedDept({ id, name });
//     setTouched((prev) => ({ ...prev, department: true }));
//     setErrors((prev) => ({ ...prev, department: "" }));
//   };

//   // thumbnail
//   const handleThumbnailChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (!file.type.startsWith("image/")) {
//       setErrors((prev) => ({ ...prev, thumbnail: "Please select an image file" }));
//       return;
//     }
//     setThumbnailFile(file);
//     setThumbnailPreview(URL.createObjectURL(file));
//     setErrors((prev) => ({ ...prev, thumbnail: "" }));
//   };

//   const uploadThumbnailToServer = async () => {
//     if (!thumbnailFile) return null;
//     try {
//       setUploading(true);
//       const fd = new FormData();
//       fd.append("file", thumbnailFile);

//       const res = await fetch(`${BeURL}/upload-thumbnail`, {
//         method: "POST",
//         credentials: "include",
//         body: fd,
//       });

//       const data = await res.json();
//       if (!data.success) throw new Error("Upload failed");

//       return {
//         url: data.file.url,
//         filename: data.file.filename,
//         mimeType: data.file.mimeType,
//         size: data.file.size,
//       };
//     } catch (err) {
//       setErrors((prev) => ({ ...prev, thumbnail: "Thumbnail upload failed" }));
//       return null;
//     } finally {
//       setUploading(false);
//     }
//   };

//   // skills handling (Enter to add)
//   const addSkill = () => {
//     const value = skillInput.trim().toLowerCase();
//     if (!value) {
//       setSkillError("Skill is required");
//       return;
//     }
//     if (skills.includes(value)) {
//       setSkillError("Skill already added");
//       return;
//     }
//     setSkills((p) => [...p, value]);
//     setSkillInput("");
//     setSkillError("");
//   };

//   const removeSkill = (s) => {
//     setSkills((p) => p.filter((i) => i !== s));
//   };

//   const handleSkillKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       addSkill();
//     }
//   };

//   // faq handling
//   const addFaq = () => {
//     if (!faq.question.trim() || !faq.answer.trim()) {
//       setFaqError("FAQ question and answer required");
//       return;
//     }
//     setFaqList((p) => [...p, faq]);
//     setFaq({ question: "", answer: "" });
//     setFaqError("");
//   };

//   const removeFaq = (index) => {
//     setFaqList((p) => p.filter((_, i) => i !== index));
//   };

//   // validate all fields before submitting; returns boolean valid
//   const validateAll = () => {

//     const newTouched = { ...touched };
//     const newErrors = { ...errors };

//     Object.keys(labels).forEach((k) => (newTouched[k] = true));

//     newTouched.department = true;

//     if (!selectedDept) {
//       newErrors.department = "Department is required";
//     } else {
//       newErrors.department = "";
//     }

//     Object.keys(labels).forEach((k) => {
//       newErrors[k] = validateField(k, form[k]);
//     });

//     // Skills
//     if (!skills || skills.length === 0) {
//       setSkillError("Add at least one skill");
//     } else {
//       setSkillError("");
//     }

//     // FAQ
//     if (!faqList || faqList.length === 0) {
//       setFaqError("Add at least one FAQ");
//     } else {
//       setFaqError("");
//     }

//     // Thumbnail
//     if (!thumbnailFile) {
//       newErrors.thumbnail = "Thumbnail is required";
//     } else {
//       newErrors.thumbnail = "";
//     }

//     setTouched(newTouched);
//     setErrors(newErrors);

//     const hasFieldErrors = Object.values(newErrors).some((v) => v && v.length > 0);

//     const skillsOk = skills.length > 0;
//     const faqOk = faqList.length > 0;
//     const deptOk = !!selectedDept;
//     const thumbOk = !!thumbnailFile;

//     return !hasFieldErrors && skillsOk && faqOk && deptOk && thumbOk;

//   };

//   // submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // validation
//     const ok = validateAll();
//     if (!ok) return; // show messages, stop submit


//     // proceed to create
//     try {
//       setCreating(true);

//       let thumbnailObj = null;
//       if (thumbnailFile) {
//         thumbnailObj = await uploadThumbnailToServer();
//         if (!thumbnailObj) {
//           setCreating(false);
//           return;
//         }
//       }

//       const payload = {
//         departmentId: selectedDept.id || selectedDept._id || selectedDept.value,
//         departmentName: selectedDept.name || selectedDept.label || selectedDept,
//         title: form.title.trim(),
//         shortDescription: form.shortDescription.trim(),
//         description: form.description.trim(),
//         level: form.level,
//         language: form.language,
//         skills,
//         faq: faqList,
//         thumbnail: thumbnailObj,
//       };

//       const res = await fetch(`${BeURL}/create-course`, {
//         method: "POST",
//         credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();

//       if (data.success) {

//         navigate(`/instructor/managecourse/${data?.courseId}`);

//         resetAll();
//         onCreated && onCreated();
//         onClose && onClose();
//       } else {
//         // backend returned failure — show as top error for now
//         setErrors((prev) => ({ ...prev, submit: data.message || "Failed to create course" }));
//       }
//     } catch (err) {
//       setErrors((prev) => ({ ...prev, submit: "Error creating course" }));
//     } finally {
//       setCreating(false);
//     }
//   };

//   // render UI
//   return (
//     <div className="fixed inset-0 bg-secondary-100/35 backdrop-blur-sm flex items-center justify-center z-50">
//       <div className="bg-white w-full max-w-lg rounded-xl p-6 space-y-4 max-h-[90vh] overflow-y-auto">
       
//        <div className="flex justify-between">
//           <h3 className="text-xl font-semibold">Create Course</h3>
//           <button onClick={() => {
//             resetAll();
//             onClose && onClose();
//           }}><RiCloseFill /></button>
//        </div>

//         {/* Department */}
//         {/* <div>
//           <label className="text-sm font-medium">Department <span className="text-red-500">*</span></label>
//           <div className="flex flex-wrap gap-2 mt-2">
//             {departments.map((d) => {
//               const id = d.id || d._id || d.value;
//               const name = d.name || d.label || d;
//               const isSelected = selectedDept && selectedDept.id === id;
//               return (
//                 <button
//                   key={id}
//                   type="button"
//                   onClick={() => handleSelectDept(d)}
//                   className={`px-3 py-1 rounded-full border ${isSelected ? "bg-primary-600 text-white" : ""}`}
//                 >
//                   {name}
//                 </button>
//               );
//             })}
//           </div>
//           {touched.department && errors.department && <p className="text-xs text-red-500 mt-1">{errors.department}</p>}
//         </div> */}

//         <form onSubmit={handleSubmit} className="space-y-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
//           {/* Department */}
//           <div>
//             <label className="text-sm font-medium">
//               Department <span className="text-red-500">*</span>
//             </label>

//             <select
//               value={selectedDept?.id || ""}
//               onChange={(e) => {
//                 const dept = departments.find(
//                   (d) => (d.id || d._id || d.value) === e.target.value
//                 );

//                 if (dept) handleSelectDept(dept);
//               }}
//               className="w-full mt-2 rounded-lg px-3 py-2 border border-gray-300"
//             >
//               <option value="">Select Department</option>

//               {departments.map((d) => {
//                 const id = d.id || d._id || d.value;
//                 const name = d.name || d.label || d;

//                 return (
//                   <option key={id} value={id}>
//                     {name}
//                   </option>
//                 );
//               })}
//             </select>

//             {touched.department && errors.department && (
//               <p className="text-xs text-red-500 mt-1">{errors.department}</p>
//             )}
//           </div>

//           {/* Title */}
//           <div>
//             <label className="text-sm font-medium">Title <span className="text-red-500">*</span></label>
//             <input
//               name="title"
//               value={form.title}
//               onChange={handleFormChange}
//               placeholder="Course Title"
//               className={`w-full rounded-lg px-3 py-2 border ${getInputClass("title")}`}
//             />
//             {renderError("title")}
//           </div>

//           {/* Short Description */}
//           <div>
//             <label className="text-sm font-medium">Short Description <span className="text-red-500">*</span></label>
//             <input
//               name="shortDescription"
//               value={form.shortDescription}
//               onChange={handleFormChange}
//               placeholder="Short Description"
//               className={`w-full rounded-lg px-3 py-2 border ${getInputClass("shortDescription")}`}
//             />
//             {renderError("shortDescription")}
//           </div>

//           {/* Description */}
//           <div>
//             <label className="text-sm font-medium">Full Description <span className="text-red-500">*</span></label>
//             <textarea
//               name="description"
//               value={form.description}
//               onChange={handleFormChange}
//               placeholder="Full Description"
//               rows={4}
//               className={`w-full rounded-lg px-3 py-2 border ${getInputClass("description")}`}
//             />
//             {renderError("description")}
//           </div>

//           {/* Level */}
//           <div>
//             <label className="text-sm font-medium">Level <span className="text-red-500">*</span></label>
//             <select
//               name="level"
//               value={form.level}
//               onChange={handleFormChange}
//               className={`w-full rounded-lg px-3 py-2 border ${getInputClass("level")}`}
//             >
//               <option value="">Select Level</option>
//               <option value="beginner">Beginner</option>
//               <option value="intermediate">Intermediate</option>
//               <option value="advanced">Advanced</option>
//             </select>
//             {renderError("level")}
//           </div>

//           {/* Language */}
//           <div>
//             <label className="text-sm font-medium">Language <span className="text-red-500">*</span></label>
//             <select
//               name="language"
//               value={form.language}
//               onChange={handleFormChange}
//               className={`w-full rounded-lg px-3 py-2 border ${getInputClass("language")}`}
//             >
//               <option value="">Select</option>
//               <option value="Tamil">Tamil</option>
//               <option value="English">English</option>
//               <option value="Hindi">Hindi</option>
//             </select>
//             {renderError("language")}
//           </div>

//           {/* Skills */}
//           <div>
//             <label className="text-sm font-medium">Skills <span className="text-red-500">*</span></label>
//             <div className="flex gap-2 mt-2">
//               <input
//                 value={skillInput}
//                 onChange={(e) => {
//                   setSkillInput(e.target.value);
//                   if (skillError) setSkillError("");
//                 }}
//                 onKeyDown={handleSkillKeyDown}
//                 placeholder="Type a skill and press Enter or click Add"
//                 className="flex-1 rounded-lg px-3 py-2 border border-gray-300"
//               />
//               <button type="button" onClick={addSkill} className="flex items-center text-primary-700 font-semibold">
//                 <IoAdd/> Add
//               </button>
//             </div>
//             {skillError && <p className="text-xs text-red-500 mt-1">{skillError}</p>}

//             <div className="flex flex-wrap gap-2 mt-2">
//               {skills.map((s) => (
//                 <span key={s} className="bg-gray-100 px-3 py-1 rounded-full text-sm flex items-center gap-2">
//                   {s}
//                   <button type="button" onClick={() => removeSkill(s)} className="text-gray-600">✕</button>
//                 </span>
//               ))}
//             </div>
//           </div>

//           {/* FAQ */}
//           <div>
//             <label className="text-sm font-medium">FAQ <span className="text-red-500">*</span></label>
//             <input
//               placeholder="Question"
//               value={faq.question}
//               onChange={(e) => {
//                 setFaq({ ...faq, question: e.target.value });
//                 if (faqError) setFaqError("");
//               }}
//               className="w-full rounded-lg px-3 py-2 border border-gray-300"
//             />
//             <textarea
//               placeholder="Answer"
//               value={faq.answer}
//               onChange={(e) => {
//                 setFaq({ ...faq, answer: e.target.value });
//                 if (faqError) setFaqError("");
//               }}
//               className="w-full rounded-lg px-3 py-2 mt-2 border border-gray-300"
//             />
//             <div className="flex justify-end">
//               <button type="button" onClick={addFaq} className="flex items-center text-primary-700 font-semibold">
//                 <IoAdd />
//                 Add FAQ
//               </button>
//             </div>
//             {faqError && <p className="text-xs text-red-500">{faqError}</p>}

//             <div className="mt-3 space-y-2">
//               {faqList.map((f, i) => (
//                 <div key={i} className="border rounded-lg p-2 flex justify-between items-start">
//                   <div>
//                     <p className="font-medium">{f.question}</p>
//                     <p className="text-sm text-gray-600">{f.answer}</p>
//                   </div>
//                   <button type="button" onClick={() => removeFaq(i)} className="text-gray-600">✕</button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Thumbnail */}
//           <div className="flex flex-col">
//             <label className="text-sm font-medium">Thumbnail <span className="text-red-500">*</span></label>
//             <input type="file" accept="image/*" onChange={handleThumbnailChange} className="mt-2" />
//             {errors.thumbnail && <p className="text-xs text-red-500 mt-1">{errors.thumbnail}</p>}
//             {thumbnailPreview && (
//               <img src={thumbnailPreview} alt="thumb" className="mt-2 w-40 h-28 object-cover rounded-md border" />
//             )}
//           </div>

//           {/* submit area */}
//           <div className="flex justify-end items-center gap-3 pt-3">
//             <button
//               type="button"
//               onClick={() => {
//                 resetAll();
//                 onClose && onClose();
//               }}
//               className="px-4 py-2 border rounded-lg"
//             >
//               Cancel
//             </button>

//             <button
//               type="submit"
//               disabled={creating || uploading}
//               className={`px-4 py-2 rounded-lg text-white ${creating || uploading ? "bg-gray-400" : "bg-primary-600"}`}
//             >
//               {creating ? "Creating..." : uploading ? "Uploading..." : "Create Course"}
//             </button>
//           </div>

//           {/* submit-level error */}
//           {errors.submit && <p className="text-sm text-red-500 mt-2">{errors.submit}</p>}
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CreateCourseModal;






import React, { useState, useContext, useEffect } from "react";
import { DContext } from "../../../context/Datacontext";
import { useNavigate } from "react-router-dom";
import { RiCloseFill } from "react-icons/ri";
import { IoAdd } from "react-icons/io5";

const CreateCourseModal = ({ open, onClose, onCreated, departments = [] }) => {
  const { BeURL } = useContext(DContext);
  const navigate = useNavigate();

  const [step, setStep] = useState(1);

  const [selectedDept, setSelectedDept] = useState(null);
  const [form, setForm] = useState({
    title: "",
    shortDescription: "",
    description: "",
    level: "",
    language: "",
  });

  const [skills, setSkills] = useState([]);
  const [skillInput, setSkillInput] = useState("");
  const [skillError, setSkillError] = useState("");

  const [faq, setFaq] = useState({ question: "", answer: "" });
  const [faqList, setFaqList] = useState([]);
  const [faqError, setFaqError] = useState("");

  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [creating, setCreating] = useState(false);

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  const labels = {
    title: "Title",
    shortDescription: "Short Description",
    description: "Description",
    level: "Level",
    language: "Language",
    department: "Department",
    thumbnail: "Thumbnail",
  };

  // -------------------------- Reset --------------------------
  const resetAll = () => {
    setStep(1);
    setSelectedDept(null);
    setForm({ title: "", shortDescription: "", description: "", level: "", language: "" });
    setSkills([]);
    setSkillInput("");
    setSkillError("");
    setFaq({ question: "", answer: "" });
    setFaqList([]);
    setFaqError("");
    setThumbnailFile(null);
    setThumbnailPreview(null);
    setUploading(false);
    setCreating(false);
    setTouched({});
    setErrors({});
  };

  useEffect(() => {
    if (!open) resetAll();
  }, [open]);

  // -------------------------- Helpers --------------------------
  const validateField = (name, value) => {
    if (!labels[name]) return "";
    if (!value || value.toString().trim() === "") return `${labels[name]} is required`;
    return "";
  };

  const validateStep = () => {
    const newErrors = {};

    if (step === 1) {
      // Step 1 validation
      newErrors.department = selectedDept ? "" : "Department is required";
      Object.keys(form).forEach((k) => (newErrors[k] = validateField(k, form[k])));
    }

    if (step === 2) {
      if (!skills.length) setSkillError("Add at least one skill");
      if (!faqList.length) setFaqError("Add at least one FAQ");
    }

    if (step === 3) {
      newErrors.thumbnail = thumbnailFile ? "" : "Thumbnail is required";
    }

    setErrors(newErrors);

    return !Object.values(newErrors).some((v) => v && v.length > 0) &&
      (step !== 2 || (skills.length && faqList.length));
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setTouched((prev) => ({ ...prev, [name]: true }));
    const err = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: err }));
  };

  const handleSelectDept = (e) => {
    const dept = departments.find((d) => (d.id || d._id || d.value) === e.target.value);
    if (dept) setSelectedDept({ id: dept.id || dept._id || dept.value, name: dept.name || dept.label || dept });
    setTouched((prev) => ({ ...prev, department: true }));
    setErrors((prev) => ({ ...prev, department: "" }));
  };

  // -------------------------- Skills --------------------------
  const addSkill = () => {
    const value = skillInput.trim().toLowerCase();
    if (!value) return setSkillError("Skill is required");
    if (skills.includes(value)) return setSkillError("Skill already added");
    setSkills((p) => [...p, value]);
    setSkillInput("");
    setSkillError("");
  };

  const removeSkill = (s) => setSkills((p) => p.filter((i) => i !== s));

  const handleSkillKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addSkill();
    }
  };

  // -------------------------- FAQ --------------------------
  const addFaq = () => {
    if (!faq.question.trim() || !faq.answer.trim()) return setFaqError("FAQ question and answer required");
    setFaqList((p) => [...p, faq]);
    setFaq({ question: "", answer: "" });
    setFaqError("");
  };

  const removeFaq = (index) => setFaqList((p) => p.filter((_, i) => i !== index));

  // -------------------------- Thumbnail --------------------------
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      setErrors((prev) => ({ ...prev, thumbnail: "Please select an image file" }));
      return;
    }
    setThumbnailFile(file);
    setThumbnailPreview(URL.createObjectURL(file));
    setErrors((prev) => ({ ...prev, thumbnail: "" }));
  };

  const uploadThumbnailToServer = async () => {
    if (!thumbnailFile) return null;
    try {
      setUploading(true);
      const fd = new FormData();
      fd.append("file", thumbnailFile);

      const res = await fetch(`${BeURL}/upload-thumbnail`, {
        method: "POST",
        credentials: "include",
        body: fd,
      });
      const data = await res.json();
      if (!data.success) throw new Error("Upload failed");
      return { url: data.file.url, filename: data.file.filename };
    } catch {
      setErrors((prev) => ({ ...prev, thumbnail: "Thumbnail upload failed" }));
      return null;
    } finally {
      setUploading(false);
    }
  };

  // -------------------------- Navigation --------------------------
  const nextStep = () => {
    if (validateStep()) setStep((prev) => Math.min(prev + 1, 3));
  };

  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  // -------------------------- Submit --------------------------
  const handleSubmit = async () => {
    if (!validateStep()) return;

    setCreating(true);
    let thumbnailObj = null;
    if (thumbnailFile) {
      thumbnailObj = await uploadThumbnailToServer();
      if (!thumbnailObj) {
        setCreating(false);
        return;
      }
    }

    const payload = {
      departmentId: selectedDept.id,
      departmentName: selectedDept.name,
      ...form,
      skills,
      faq: faqList,
      thumbnail: thumbnailObj,
    };

    try {
      const res = await fetch(`${BeURL}/create-course`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.success) {
        navigate(`/instructor/managecourse/${data.courseId}`);
        resetAll();
        onCreated?.();
        onClose?.();
      } else {
        setErrors((prev) => ({ ...prev, submit: data.message || "Failed to create course" }));
      }
    } catch {
      setErrors((prev) => ({ ...prev, submit: "Error creating course" }));
    } finally {
      setCreating(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-secondary-100 w-full max-w-3xl rounded-xl  space-y-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center bg-primary-600 px-3 py-2 text-white">
          <h3 className="text-xl font-semibold">Create Course</h3>
          <button onClick={() => { resetAll(); onClose?.(); }}><RiCloseFill /></button>
        </div>
        <div className="px-6 py-2">

        {/* Step indicator */}
        <div className="flex gap-2 mb-4">
          {[1, 2, 3].map((s) => (
            <div key={s} className={`flex-1 h-1 rounded ${step >= s ? "bg-primary-600" : "bg-gray-300"}`} />
          ))}
        </div>

        {/* Steps */}
        {step === 1 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Department */}
            <div>
              <label className="text-sm font-medium">Department <span className="text-red-500">*</span></label>
              <select value={selectedDept?.id || ""} onChange={handleSelectDept} className="w-full  rounded-lg px-3 py-2 border border-gray-300">
                <option value="">Select Department</option>
                {departments.map((d) => {
                  const id = d.id || d._id || d.value;
                  const name = d.name || d.label || d;
                  return <option key={id} value={id}>{name}</option>;
                })}
              </select>
              {errors.department && <p className="text-xs text-red-500 mt-1">{errors.department}</p>}
            </div>

            {/* Title */}
            <div>
              <label className="text-sm font-medium">Title <span className="text-red-500">*</span></label>
              <input name="title" value={form.title} onChange={handleFormChange} placeholder="Course Title" className="w-full rounded-lg  px-3 py-2 border border-gray-300" />
              {errors.title && <p className="text-xs text-red-500 mt-1">{errors.title}</p>}
            </div>

            {/* Short Description */}
            <div className="md:col-span-2">
              <label className="text-sm font-medium">Short Description <span className="text-red-500">*</span></label>
              <input name="shortDescription" value={form.shortDescription} onChange={handleFormChange} placeholder="Short Description" className="w-full rounded-lg px-3 py-2 border border-gray-300" />
              {errors.shortDescription && <p className="text-xs text-red-500 mt-1">{errors.shortDescription}</p>}
            </div>

            {/* Description */}
            <div className="md:col-span-2">
              <label className="text-sm font-medium">Full Description <span className="text-red-500">*</span></label>
              <textarea name="description" value={form.description} onChange={handleFormChange} rows={4} placeholder="Full Description" className="w-full rounded-lg px-3 py-2 border border-gray-300" />
              {errors.description && <p className="text-xs text-red-500 mt-1">{errors.description}</p>}
            </div>

            {/* Level */}
            <div>
              <label className="text-sm font-medium">Level <span className="text-red-500">*</span></label>
              <select name="level" value={form.level} onChange={handleFormChange} className="w-full  rounded-lg px-3 py-2 border border-gray-300">
                <option value="">Select Level</option>
                <option value="beginner">Beginner</option>
                <option value="intermediate">Intermediate</option>
                <option value="advanced">Advanced</option>
              </select>
              {errors.level && <p className="text-xs text-red-500 mt-1">{errors.level}</p>}
            </div>

            {/* Language */}
            <div>
              <label className="text-sm font-medium">Language <span className="text-red-500">*</span></label>
              <select name="language" value={form.language} onChange={handleFormChange} className="w-full rounded-lg px-3 py-2 border border-gray-300">
                <option value="">Select</option>
                <option value="Tamil">Tamil</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
              </select>
              {errors.language && <p className="text-xs text-red-500 mt-1">{errors.language}</p>}
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="space-y-4">
            {/* Skills */}
            <div>
              <label className="text-sm font-medium">Skills <span className="text-red-500">*</span></label>
              <div className="flex gap-2 mt-2">
                <input value={skillInput} onChange={(e) => { setSkillInput(e.target.value); if (skillError) setSkillError(""); }} onKeyDown={handleSkillKeyDown} placeholder="Type a skill and press Enter or click Add" className="flex-1 rounded-lg px-3 py-2 border border-gray-300" />
                <button type="button" onClick={addSkill} className="flex items-center text-primary-700 font-semibold"><IoAdd /> Add</button>
              </div>
              {skillError && <p className="text-xs text-red-500 mt-1">{skillError}</p>}
              <div className="flex flex-wrap gap-2 mt-2">
                {skills.map((s) => (
                  <span key={s} className="bg-gray-100 px-3 py-1 rounded-full text-sm flex items-center gap-2">
                    {s} <button type="button" onClick={() => removeSkill(s)} className="text-gray-600">✕</button>
                  </span>
                ))}
              </div>
            </div>

            {/* FAQ */}
            <div>
              <label className="text-sm font-medium">FAQ <span className="text-red-500">*</span></label>
              <input placeholder="Question" value={faq.question} onChange={(e) => { setFaq({ ...faq, question: e.target.value }); if (faqError) setFaqError(""); }} className="w-full rounded-lg px-3 py-2 border border-gray-300 mt-2" />
              <textarea placeholder="Answer" value={faq.answer} onChange={(e) => { setFaq({ ...faq, answer: e.target.value }); if (faqError) setFaqError(""); }} className="w-full rounded-lg px-3 py-2 border border-gray-300 mt-2" />
              <div className="flex justify-end mt-1">
                <button type="button" onClick={addFaq} className="flex items-center text-primary-700 font-semibold"><IoAdd /> Add FAQ</button>
              </div>
              {faqError && <p className="text-xs text-red-500 mt-1">{faqError}</p>}
              <div className="mt-3 space-y-2">
                {faqList.map((f, i) => (
                  <div key={i} className="border rounded-lg p-2 flex justify-between items-start">
                    <div>
                      <p className="font-medium">{f.question}</p>
                      <p className="text-sm text-gray-600">{f.answer}</p>
                    </div>
                    <button type="button" onClick={() => removeFaq(i)} className="text-gray-600">✕</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="flex flex-col">
            <label className="text-sm font-medium">Thumbnail <span className="text-red-500">*</span></label>
            <input type="file" accept="image/*" onChange={handleThumbnailChange} className="mt-2" />
            {errors.thumbnail && <p className="text-xs text-red-500 mt-1">{errors.thumbnail}</p>}
            {thumbnailPreview && <img src={thumbnailPreview} alt="thumb" className="mt-2 w-40 h-28 object-cover rounded-md border" />}
          </div>
        )}

        {/* Navigation */}
        <div className="flex justify-between mt-6">
          <button type="button" onClick={prevStep} disabled={step === 1} className="px-4 py-2 border rounded-lg">Back</button>
          {step < 3 ? (
            <button type="button" onClick={nextStep} className="px-4 py-2 bg-primary-600 text-white rounded-lg">Next</button>
          ) : (
            <button type="button" onClick={handleSubmit} disabled={creating || uploading} className={`px-4 py-2 rounded-lg text-white ${creating || uploading ? "bg-gray-400" : "bg-primary-600"}`}>
              {creating ? "Creating..." : uploading ? "Uploading..." : "Create Course"}
            </button>
          )}
        </div>

        {errors.submit && <p className="text-sm text-red-500 mt-2">{errors.submit}</p>}
        </div>
      </div>
    </div>
  );
};

export default CreateCourseModal;